import types from './types'

const updateSavedSearch = (query, nameSearch, userSearchId) => (dispatch) => {
  const updatedQuery = { ...query }
  // Don't save AcceptanceLikelihood filter, only for student search
  if (updatedQuery.AcceptanceLikelihood) delete updatedQuery.AcceptanceLikelihood
  dispatch({
    type: types.UPDATE_SAVED_SEARCH,
    payload: {
      query: updatedQuery,
      nameSearch,
      userSearchId,
    },
  })
}

export default {
  updateSavedSearch,
}
